// import airtelIcon from "../assets/icons/airtel_logo_small.svg";
// import helpAndSupport from "../assets/icons/help&support.svg";
// import termsAndConditions from "../assets/icons/t&c.svg";
// import logout from "../assets/icons/logout.svg";
// import aboutUs from "../assets/icons/aboutus.svg";
// import balRightArrowIcn from "../assets/icons/bal-right-icn.svg";
// import balRefreshIcn from "../assets/icons/bal-refresh-icn.svg";
// import whiteLeftArrowIcn from "../assets/icons/white_left_arrow.svg";
// import packIcn from "../assets/icons/pack_icn.svg";
// import closeIcn from "../assets/icons/ic_close.svg";
// import offerIcn from "../assets/icons/offer.svg";
// import successfulIcn from "../assets/icons/successful.svg";
// import redXIcn from "../assets/icons/red-x-icon.svg";
// import downIcn from "../assets/icons/down-icon.svg";
// import airtelIcn from "../assets/icons/airtel.svg";
// import safaricomIcn from "../assets/icons/safaricom.svg";
// import medishop_icon from "../assets/icons/medishop_icon.svg";
// import filterIcn from "../assets/icons/filter.svg";
// import searchIcn from "../assets/icons/search.svg";
// import no_file_icon from "../assets/icons/no-file.svg";
// import backIcn from "../assets/icons/back_black.svg";
// import mpesa from "../assets/icons/mpesa.png";
// import info from "../assets/icons/info.svg";
// import edit from "../assets/icons/edit.svg";
// import ic_ban_red from "../assets/icons/ic_ban_red.svg";
// import blockIcon from "../assets/icons/ic_ban.svg";
// import exclamation from "../assets/icons/ic_xslamation_icon.svg";
// import clock from "../assets/icons/ic_clock.svg";
// import shareIcn from "../assets/icons/share-icn.svg";
// import refreshIcon from "../assets/icons/refresh_reload.svg";
// import airtimeWalletIcn from "../assets/icons/airtime_wallet.svg";
// import oops from "../assets/icons/oops.svg";
// import checkIcon from "../assets/icons/ic_check.svg";
// import mobileVerify from "../assets/icons/mobile_verify.svg";
// import clock_time from "../assets/icons/clock_time.svg";
// import redCrossIcon from "../assets/icons/ic-red-close.svg";
// import mobileSuccessTick from "../assets/icons/mobileSuccessTick.svg";
// import mobileFailedTick from "../assets/icons/mobileFailedTick.svg";
// import timeoutIcon from "../assets/icons/ic-timeout.svg";
// import accountLockedIcn from "../assets/icons/acc_locked_icn.svg";
// import clearIcn from "../assets/icons/clear-icn.svg";
// import incompatible_Icn from "../assets/icons/incompatible.png";
// import refreshEmpty from "../assets/icons/refresh-empty.svg";
// import securityQuestionIcn from "../assets/icons/security_question_icn.svg";
// import tip_Icn from "../assets/icons/tips_icn.svg";
// import dot_Icn from "../assets/icons/dot_icn.svg";
// import crossIcn from "../assets/icons/ic_cancel.svg";
// import languageIcn from "../assets/icons/ic_language.svg";
// import languageWhiteIcn from "../assets/icons/ic_language_white.svg";
// import greenCheckIcn from "../assets/icons/ic_green_check.svg";
// import greyCheckIcn from "../assets/icons/ic_grey_check.svg";
// import errorIcn from "../assets/icons/error.svg";
// import airtel_lite_icn from "../assets/icons/airtel_lite_icn.svg";
// import changePin from "../assets/icons/change_pin.svg";
// import manageQuestion from "../assets/icons/manageQuestion.svg";
// import warningIcn from "../assets/icons/am_warning.svg";
// import forgotPinIcn from "../assets/icons/forgot-pin.svg";
// import airtelShop from "../assets/icons/airtel_shop.svg";
// import callCC from "../assets/icons/call-cc.svg";
// import refreshIconWithBorder from "../assets/icons/refresh_icon_with_border.svg";
// import KE from "../assets/icons/flag/KE.png";
// import TZ from "../assets/icons/flag/TZ.png";
// import MW from "../assets/icons/flag/MW.png";
// import ZM from "../assets/icons/flag/ZM.png";
// import GA from "../assets/icons/flag/GA.png";
// import CD from "../assets/icons/flag/CD.png";
// import UG from "../assets/icons/flag/UG.png";
// import exclamationMark from "../assets/icons/exclamation_mark.svg";
// import airtel_home_view_icon from "../assets/icons/airtel_home_view_icon.png";
// import AccordianUpIcn from "../assets/icons/dropdownUp.svg";
// import AccordianDownIcn from "../assets/icons/dropdownDown.svg";
// import faqIcn from "../assets/icons/ic_faq.svg";
// import loanConcentIcn from "../assets/icons/loan_concent.png"
// import voiceLoanCatIcn from "../assets/icons/voice_loan_cat.png";
// import dataLoanCatIcn from "../assets/icons/data_loan_cat.png";
// import airtimeLoanCatIcn from "../assets/icons/airtime_loan_cat.png";
// import comboandmoreLoanCatIcn from "../assets/icons/como_and_more.svg";
// import loanCardBgIcn from "../assets/icons/loan_card_bg_icn.svg";
// import loanIcn from "../assets/icons/ic_loan.svg";
// import noLoanTransactionsIcn from "../assets/icons/no_loan_transaction.svg";

// import webPageMobileIcn from "../assets/icons/web_page_phone_icn.png";
// import webPageSlide1Icn from "../assets/icons/web_page_slide1_icn.svg";
// import webPageSlide2Icn from "../assets/icons/web_page_slide2_icn.svg";
// import webPageSlide3Icn from "../assets/icons/web_page_slide3_icn.svg";
// import webPageSlide4Icn from "../assets/icons/web_page_slide4_icn.svg";
// import webPageSlide5Icn from "../assets/icons/web_page_slide5_icn.svg";
// import webPageMobileIcn1 from "../assets/icons/web_page_phone_icn1.png";
// import webPageSlide1Icn1 from "../assets/icons/web_page_slide1_icn1.svg";
// import webPageSlide3Icn1 from "../assets/icons/web_page_slide3_icn1.svg";
// import webPageSlide5Icn1 from "../assets/icons/web_page_slide5_icn1.svg";
// import webPageBgIcn from "../assets/icons/web_page_bg_icn.svg";
// import airtelQRKE from "../assets/icons/QR-KE.svg";
// import airtelQRCD from "../assets/icons/QR-CD.svg";
// import airtelQRGA from "../assets/icons/QR-GA.svg";
// import airtelQRMW from "../assets/icons/QR-MW.svg";
// import airtelQRUG from "../assets/icons/QR-UG.svg";
// import airtelQRTZ from "../assets/icons/QR-TZ.svg";
// import airtelQRZM from "../assets/icons/QR-ZM.svg";
// import no_internet_icn from "../assets/icons/no_internet_icn.png";

// import batterySavingIcnLight from "../assets/icons/battarySaverIcnLightMode.svg";
// import batterySavingIcnDark from "../assets/icons/battarySaverIcnDarkMode.svg";
// import airtel_humburger_icn from "../assets/icons/airtel-Fav-Icon.svg"

const CDN_SERVER_URL = `/${process.env.REACT_APP_CDN_URL}icons`;

const icons = {
    "svg_sprite": `${CDN_SERVER_URL}/svg_sprite.svg`,
    "airtelIcon": `${CDN_SERVER_URL}/airtel_logo_small.svg`,
    "airtelLogo": `${CDN_SERVER_URL}/airtel_icon_x72.svg`,
    "hburgerIcon": `${CDN_SERVER_URL}/ham_menu.svg`,
    "airtel": `${CDN_SERVER_URL}/airtel-logo.svg`,
    "amWallet": `${CDN_SERVER_URL}/am_wallet_icon.svg`,
    "showBal": `${CDN_SERVER_URL}/show_bal.svg`,
    "hideBal": `${CDN_SERVER_URL}/hide_bal.svg`,
    "forward": `${CDN_SERVER_URL}/frwd.svg`,
    "phone": `${CDN_SERVER_URL}/call.svg`,
    "email": `${CDN_SERVER_URL}/email.svg`,
    "backWhite": `${CDN_SERVER_URL}/back_white.svg`,
    "address": `${CDN_SERVER_URL}/address.svg`,
    "ig": `${CDN_SERVER_URL}/ig.svg`,
    "ln": `${CDN_SERVER_URL}/linkedin.svg`,
    "fb": `${CDN_SERVER_URL}/fb.svg`,
    "x": `${CDN_SERVER_URL}/x.svg`,
    "yt": `${CDN_SERVER_URL}/youtube.svg`,
    "lock": `${CDN_SERVER_URL}/locked.svg`,
    "amBarred": `${CDN_SERVER_URL}/warning-am-icn.svg`,
    "amDebitIcon": `${CDN_SERVER_URL}/payment-debit.svg`,
    "amCreditIcon": `${CDN_SERVER_URL}/payment-credit.svg`,
    "noTransactionsIcn": `${CDN_SERVER_URL}/no transaction.svg`,
    "balRightArrow": `${CDN_SERVER_URL}/bal-right-icn.svg`,
    "balRefresh": `${CDN_SERVER_URL}/bal-refresh-icn.svg`,
    "packIcn": `${CDN_SERVER_URL}/pack_icn.svg`,
    "closeIcn": `${CDN_SERVER_URL}/ic_close.svg`,
    "offerIcn": `${CDN_SERVER_URL}/offer.svg`,
    "successfullIcn": `${CDN_SERVER_URL}/successful.svg`,
    "redXIcn": `${CDN_SERVER_URL}/red-x-icon.svg`,
    "downIcn": `${CDN_SERVER_URL}/down-icon.svg`,
    "operator/airtel.png": `${CDN_SERVER_URL}/airtel.svg`,
    "operator/safaricom.png": `${CDN_SERVER_URL}/safaricom.svg`,
    "operator/orange.png": `${CDN_SERVER_URL}/orange.svg`,
    "medishop_icon": `${CDN_SERVER_URL}/medishop_icon.svg`,
    "filterIcn": `${CDN_SERVER_URL}/filter.svg`,
    "searchIcn": `${CDN_SERVER_URL}/search.svg`,
    "no_file_icon": `${CDN_SERVER_URL}/no-file.svg`,
    "backIcn": `${CDN_SERVER_URL}/back_black.svg`,
    "mpesa": `${CDN_SERVER_URL}/mpesa.png`,
    "info": `${CDN_SERVER_URL}/info.svg`,
    "edit": `${CDN_SERVER_URL}/edit.svg`,
    "ic_ban_red": `${CDN_SERVER_URL}/ic_ban_red.svg`,
    "blockIcon": `${CDN_SERVER_URL}/ic_ban.svg`,
    "exclamation": `${CDN_SERVER_URL}/ic_xslamation_icon.svg`,
    "clock": `${CDN_SERVER_URL}/ic_clock.svg`,
    "shareIcn": `${CDN_SERVER_URL}/share-icn.svg`,
    "refreshIcon": `${CDN_SERVER_URL}/refresh_reload.svg`,
    "airtimeWallet": `${CDN_SERVER_URL}/airtime_wallet.svg`,
    "oops": `${CDN_SERVER_URL}/oops.svg`,
    "checkIcon": `${CDN_SERVER_URL}/ic_check.svg`,
    "mobileVerify": `${CDN_SERVER_URL}/mobile_verify.svg`,
    "clock_time": `${CDN_SERVER_URL}/clock_time.svg`,
    "redCloseIcon": `${CDN_SERVER_URL}/ic-red-close.svg`,
    "mobileSuccessTick": `${CDN_SERVER_URL}/mobileSuccessTick.svg`,
    "mobileFailedTick": `${CDN_SERVER_URL}/mobileFailedTick.svg`,
    "timeoutIcon": `${CDN_SERVER_URL}/ic-timeout.svg`,
    "accountLockedIcn": `${CDN_SERVER_URL}/acc_locked_icn.svg`,
    "clearIcn": `${CDN_SERVER_URL}/clear-icn.svg`,
    "refreshEmpty": `${CDN_SERVER_URL}/bal-refresh-icn.svg`,
    "crossIcn": `${CDN_SERVER_URL}/ic_cancel.svg`,
    "languageWhite": `${CDN_SERVER_URL}/ic_language_white.svg`,
    "greenCheck": `${CDN_SERVER_URL}/ic_green_check.svg`,
    "greyCheck": `${CDN_SERVER_URL}/ic_grey_check.svg`,
    "errorIcn": `${CDN_SERVER_URL}/error.svg`,
    "airtelShopIcn": `${CDN_SERVER_URL}/airtel_shop.svg`,
    "callCCIcn": `${CDN_SERVER_URL}/call-cc.svg`,
    "refreshIconWithBorder": `${CDN_SERVER_URL}/refresh_icon_with_border.svg`,
    "exclamationMark": `${CDN_SERVER_URL}/exclamation_mark.svg`,
    "loanConfirmIcn": `${CDN_SERVER_URL}/loan_consent.png`,
    "loanCardBgIcn": `${CDN_SERVER_URL}/loan_card_bg_icn.svg`,
    "loanIcn": `${CDN_SERVER_URL}/ic_loan.svg`,
    "VOICELoanCatIcn": `${CDN_SERVER_URL}/voice_loan_cat.png`,
    "DATALoanCatIcn": `${CDN_SERVER_URL}/data_loan_cat.png`,
    "AIRTIMELoanCatIcn": `${CDN_SERVER_URL}/airtime_loan_cat.png`,
    "COMBO&MORELoanCatIcn": `${CDN_SERVER_URL}/como_and_more.svg`,
    "noLoanTransactionsIcn": `${CDN_SERVER_URL}/no_loan_txn_icn.svg`,
    "operator/ttcl.png": `${CDN_SERVER_URL}/ttcl.png`,
    "operator/tigo.png": `${CDN_SERVER_URL}/tigo.png`,
    "operator/tnm.png": `${CDN_SERVER_URL}/tnm.png`,
    "operator/halotel.png": `${CDN_SERVER_URL}/halotel.png`,
    "operator/mtn.png": `${CDN_SERVER_URL}/mtn.png`,
    "operator/vodacom.png": `${CDN_SERVER_URL}/vodacom.png`,
    "smartcash": `${CDN_SERVER_URL}/smartcash_icn.svg`,
    "infoLightIcn": `${CDN_SERVER_URL}/ic_info_light`,
    "infoDarkIcn": `${CDN_SERVER_URL}/ic_info_dark`,
    "visa": `${CDN_SERVER_URL}/visa.png`,
    "americanExpress": `${CDN_SERVER_URL}/americanExpress.png`,
    "discover": `${CDN_SERVER_URL}/discover.png`,
    "masterCard": `${CDN_SERVER_URL}/masterCard.png`
}

export const browserIcns = {
    'chromIcn': `${CDN_SERVER_URL}/chrome_icn.svg`,
    'safariIcn': `${CDN_SERVER_URL}/safari_icn.svg`,
    'operaIcn': `${CDN_SERVER_URL}/opera_icn.svg`,
    'samsungIcn': `${CDN_SERVER_URL}/samsung_icn.svg`,
    'miIcn': `${CDN_SERVER_URL}/mi_icn.svg`,
    'pheonixIcn': `${CDN_SERVER_URL}/pheonix_icn.svg`
}

export const flag = {
    'KE': `${CDN_SERVER_URL}/flag/KE.png`,
    'TZ': `${CDN_SERVER_URL}/flag/TZ.png`,
    'GA': `${CDN_SERVER_URL}/flag/GA.png`,
    'ZM': `${CDN_SERVER_URL}/flag/ZM.png`,
    'MW': `${CDN_SERVER_URL}/flag/MW.png`,
    'CD': `${CDN_SERVER_URL}/flag/CD.png`,
    'UG': `${CDN_SERVER_URL}/flag/UG.png`,
    'NG': `${CDN_SERVER_URL}/flag/NG.png`,
    'MG': `${CDN_SERVER_URL}/flag/MG.png`,
    'CG': `${CDN_SERVER_URL}/flag/CG.png`,
    'TD': `${CDN_SERVER_URL}/flag/TD.png`,
    'NE': `${CDN_SERVER_URL}/flag/NE.png`,
    'RW': `${CDN_SERVER_URL}/flag/RW.png`,
    'SC': `${CDN_SERVER_URL}/flag/SC.png`
}

export const appSettingsIcns = {

    "whiteForward": `${CDN_SERVER_URL}/whiteForward.svg`,
}

export const AccordianIcn = {
    "upIcn": `${CDN_SERVER_URL}/dropdownUp.svg`,
    "downIcn": `${CDN_SERVER_URL}/dropdownDown.svg`
}

export const incompatibleIcn = `${CDN_SERVER_URL}/incompatible.png`;
export const securityQuestionsIcn = `${CDN_SERVER_URL}/security_question_icn.svg`;
export const tipIcn = `${CDN_SERVER_URL}/tips_icn.svg`;
export const dotIcn = `${CDN_SERVER_URL}/dot_icn.svg`;
export const airtelLiteIcn = `${CDN_SERVER_URL}/airtel_lite_icn.svg`;
export const amWarningIcn = `${CDN_SERVER_URL}/am_warning.svg`;
export const airtelHomeViewIcon = `${CDN_SERVER_URL}/airtel_home_view_icon.png`;
export const noInternetIcn = `${CDN_SERVER_URL}/no_internet_icn.png`


export default icons;

export const webLandingPageIcns = {
    'webPageMobileIcn': `${CDN_SERVER_URL}/web_page_phone_icn.png`,
    "webPageSlide1Icn": `${CDN_SERVER_URL}/web_page_slide1_icn.svg`,
    "webPageSlide2Icn": `${CDN_SERVER_URL}/web_page_slide2_icn.svg`,
    "webPageSlide3Icn": `${CDN_SERVER_URL}/web_page_slide3_icn.svg`,
    "webPageSlide4Icn": `${CDN_SERVER_URL}/web_page_slide4_icn.svg`,
    "webPageSlide5Icn": `${CDN_SERVER_URL}/web_page_slide5_icn.svg`,
    "airtelQRKE": `${CDN_SERVER_URL}/QR-KE.svg`,
    "airtelQRGA": `${CDN_SERVER_URL}/QR-GA.svg`,
    "airtelQRMW": `${CDN_SERVER_URL}/QR-MW.svg`,
    "airtelQRCD": `${CDN_SERVER_URL}/QR-CD.svg`,
    "airtelQRTZ": `${CDN_SERVER_URL}/QR-TZ.svg`,
    "airtelQRZM": `${CDN_SERVER_URL}/QR-ZM.svg`,
    "airtelQRUG": `${CDN_SERVER_URL}/QR-UG.svg`,
    "airtelQRMG": `${CDN_SERVER_URL}/QR-MG.svg`,
    "airtelQRCG": `${CDN_SERVER_URL}/QR-CG.svg`,
    "airtelQRTD": `${CDN_SERVER_URL}/QR-TD.svg`,
    "airtelQRNE": `${CDN_SERVER_URL}/QR-NE.svg`,
    "airtelQRRW": `${CDN_SERVER_URL}/QR-RW.svg`,
    "airtelQRSC": `${CDN_SERVER_URL}/QR-SC.svg`
}
export const webLandingPageIcnsPaybills = {
    'webPageMobileIcn': `${CDN_SERVER_URL}/web_page_phone_icn1.png`,
    "webPageSlide1Icn": `${CDN_SERVER_URL}/web_page_slide1_icn1.svg`,
    "webPageSlide2Icn": `${CDN_SERVER_URL}/web_page_slide2_icn.svg`,
    "webPageSlide3Icn": `${CDN_SERVER_URL}/web_page_slide3_icn1.svg`,
    "webPageSlide4Icn": `${CDN_SERVER_URL}/web_page_slide4_icn.svg`,
    "webPageSlide5Icn": `${CDN_SERVER_URL}/web_page_slide5_icn1.svg`
}

export const webLandingPageIcnsNG = {
    'webPageMobileIcn': `${CDN_SERVER_URL}/web_page_phone_icn2.png`,
    "webPageSlide1Icn": `${CDN_SERVER_URL}/web_page_slide1_icn2.svg`,
    "webPageSlide2Icn": `${CDN_SERVER_URL}/web_page_slide2_icn2.svg`,
    "webPageSlide3Icn": `${CDN_SERVER_URL}/web_page_slide3_icn2.svg`,
    "webPageSlide4Icn": `${CDN_SERVER_URL}/web_page_slide4_icn2.svg`,
    "airtelQR": `${CDN_SERVER_URL}/QR-NG.svg`
}

export const webLandingPageIcnSet = {
    NG: webLandingPageIcnsNG,
    paybills: webLandingPageIcnsPaybills,
    default: webLandingPageIcns
};

export const batterySavingIcnLightMode = `${CDN_SERVER_URL}/battarySaverIcnLightMode.svg`;
export const batterySavingIcnDarkMode = `${CDN_SERVER_URL}/battarySaverIcnDarkMode.svg`;
export const airtelHumburgerIcn = `${CDN_SERVER_URL}/airtel-Fav-Icon.svg`;
export const ic_cancel = `${CDN_SERVER_URL}/ic_cancel.svg`;
export const ios_guide = `${CDN_SERVER_URL}/ios_aths.png`;
export const ic_add = `${CDN_SERVER_URL}/ic_add.svg`;
export const v2_ic_add = `${CDN_SERVER_URL}/plus_round_icon.svg`;
export const ic_green_tick = `${CDN_SERVER_URL}/ic_online.svg`;
export const backIcn = `${CDN_SERVER_URL}/ic_back.svg`;
export const closeIcn = `${CDN_SERVER_URL}/cancel.svg`;
export const ic_home = `${CDN_SERVER_URL}/ic_home.svg`;
export const ic_frwd = `${CDN_SERVER_URL}/ic_frwd.svg`;
export const ic_blue_frwd = `${CDN_SERVER_URL}/ic_blue_frwd.svg`;
export const offlineIcon = `${CDN_SERVER_URL}/ic_offline.svg`;
export const icRefresh = `${CDN_SERVER_URL}/ic_refresh.svg`;
export const ic_cancel_red = `${CDN_SERVER_URL}/ic_cancel_red.svg`;
export const appStoreIcn = `${CDN_SERVER_URL}/ic_appstore.svg`;
export const playStoreIcn = `${CDN_SERVER_URL}/ic_playstore.svg`;
export const browserNotSupportedIcn = `${CDN_SERVER_URL}/browser_not_supported_icn.svg`;
export const browserUpdateIcn = `${CDN_SERVER_URL}/update_browser_icn.svg`;
export const postPaidSimIcn = `${CDN_SERVER_URL}/post_paid_sim_icn.svg`;
export const simIcn = `${CDN_SERVER_URL}/sim_icn.svg`;
export const wifiBoxIcn = `${CDN_SERVER_URL}/wifi_box_icn.svg`;
export const screenNotSupportedIcn = `${CDN_SERVER_URL}/screen_not_supported_icn.svg`
export const ic_star_outline = `${CDN_SERVER_URL}/ic_star_outline.svg`;
export const ic_star = `${CDN_SERVER_URL}/ic_star.png`;
export const image_placeholder = `${CDN_SERVER_URL}/image_placeholder.svg`;
export const extra_airtime_icn = `${CDN_SERVER_URL}/extra_airtime_icn.svg`;
export const secure_payment_icn = `${CDN_SERVER_URL}/secure_payment_icn.svg`;

export const LOCAL_ICON_LIST = {
    airtel_icn_white: "airtel_icn_white",
    "airtel-Fav-Icon": "airtel-Fav-Icon",
    airtel: "airtel",
    back_black: "back_black",
    back_white: "back_white",
    chev_frwd: "chev_frwd",
    forward_black_icn: "forward_black_icn",
    frwd: "frwd",
    ic_blue_frwd: "ic_blue_frwd",
    whiteForward: "whiteForward",
    ic_humburger: "ic_humburger",
    ic_humburger_white: "ic_humburger_white",
    battarySaverIcnDarkMode: "battarySaverIcnDarkMode",
    battarySaverIcnLightMode: "battarySaverIcnLightMode",
    locked: "locked",
    acc_locked_icn: "acc_locked_icn",
    ic_close: "ic_close",
    ic_close_white: "ic_close_white",
    successful: "successful",
    share: "share",
    "share-white": "share-white",
    "red-x-icon": "red-x-icon",
    ic_clock: "ic_clock",
    ic_check: "ic_check",
    ic_cancel: "ic_cancel",
    ic_cancel_red: "ic_cancel_red",
    ic_star_outline: "ic_star_outline",
    ic_star: "ic_star"
  }